export * from './icons';
export * from './utils';
export * from './modules';
import * as AllIcons_ from './icons';
import * as ModuleIcons from './modules';
export const AllIcons = {
  ...AllIcons_,
  ...ModuleIcons,
};
